import { combineReducers } from "redux";
import { currency } from "./currency/reducers";
import { currencies } from "./currencies/reducers";
import { paymentGateways } from "./payment-gateways/reducers";
import { paymentGateway } from "./payment-gateway/reducers";
import { orders } from "./orders/reducers";
import { transaction } from "./transactions/reducers";

export const transactions = combineReducers({
  currency,
  transaction,
  currencies,
  orders,
  paymentGateways,
  paymentGateway,
});
